import React, { useState } from 'react';
import { Select, Tabs, AutoComplete, Collapse } from 'antd';
import { DeleteOutlined, PlusOutlined, CloseOutlined, EditOutlined } from '@ant-design/icons';

const EducationInfo = ({ educationData, languageData, computerSkillsData, coursesData, setEducationData, setLanguageData, setComputerSkillsData, setCoursesData, selectors }) => {

    const [showEducationModal, setShowEducationModal] = useState(false);
    const [editEducation, setEditEducation] = useState(false);
    const [editEducationIndex, setEditEducationIndex] = useState(-1);
    const [newEducationData, setNewEducationData] =  useState({
        Start: '',
        End: '',
        EducationType: {
            Name: '',
            UID: ''
        },
        EducationKind: {
            Name: '',
            UID: ''
        },
        Institution: {
            Name: '',
            UID: ''
        },
        Faculty: '',
        Speciality: {
            Name: '',
            UID: ''
        },
        DocTypeEducation: {
            Name: '',
            UID: ''
        },
        DocSeries: '',
        DocNumber: '',
        DocDateIssued: ''
    });
    const [showLanguageModal, setShowLanguageModal] = useState(false);
    const [editLanguage, setEditLanguage] = useState(false);
    const [editLanguageIndex, setEditLanguageIndex] = useState(-1);
    const [newLanguageData, setNewLanguageData] = useState({
        Language: {
            Name: '',
            UID: ''
        },
        LanguageDegree: {
            Name: '',
            UID: ''
        }
    });
    const [showComputerSkillsModal, setShowComputerSkillsModal] = useState(false);
    const [editComputerSkill, setEditComputerSkill] = useState(false);
    const [editComputerSkillIndex, setEditComputerSkillIndex] = useState(0);
    const [newComputerSkillData, setNewComputerSkillData] = useState({
        Software: {
            Name: '',
            UID: ''
        },
        SoftwareLevel: {
            Name: '',
            UID: ''
        }
    });
    const [showCoursesModal, setShowCoursesModal] = useState(false);
    const [editCourse, setEditCourse] = useState(false);
    const [editCourseSkillIndex, setEditCourseIndex] = useState(0);
    const [newCourseData, setNewCourseData] = useState({
        Name: "",
        StartDate: "",
        EndDate: ""
    });
    
    const handleEducationChange = (e, option) => {
        let { name, value, dataset } = typeof e === "string" ? option : e.target;
        const { parent } = dataset;
        if(name === 'Start' || name === 'End' || name === 'DocDateIssued') value += 'T00:00:00';
        if(parent) {
            if(dataset.uid) {
                setNewEducationData(prevState => ({
                    ...prevState,
                    [parent]: {
                        ...prevState[parent],
                        [name]: value,
                        UID: dataset.uid
                    }
                }));
            } else {
                setNewEducationData(prevState => ({
                    ...prevState,
                    [parent]: {
                        ...prevState[parent],
                        [name]: value
                    }
                }));
            }
        } else{            
            setNewEducationData(prevState => ({
                ...prevState,
                [name]: value
            }));
        }        
    };

    const handleInstitutionChange = (value) => {
        let parent = 'Institution';
        setNewEducationData(prevState => ({
            ...prevState,
            [parent]: {
                ...prevState[parent],
                Name: value,
                UID: ''
            }
        }));
    }
    
    const handleSpecialityChange = (value) => {
        let parent = 'Speciality';
        setNewEducationData(prevState => ({
            ...prevState,
            [parent]: {
                ...prevState[parent],
                Name: value,
                UID: ''
            }
        }));
    }
    
    const handleEducationTypeChange = (value) => {
        let parent = 'EducationType';
        setNewEducationData(prevState => ({
            ...prevState,
            [parent]: {
                ...prevState[parent],
                Name: value,
                UID: ''
            }
        }));
    }
    
    const handleAddEducationRow = (e) => {
        e.preventDefault();
        if(editEducation) {
            setEducationData(prevData => {
                const newData = [...prevData];
                newData[editEducationIndex] = newEducationData;
                return newData;
            });            
        } else {
            newEducationData.Deletable = true;
            setEducationData(prevData => {
                if (prevData.length === 0 || (prevData.length === 1 && isObjectEmpty(prevData))) {
                    return [newEducationData];
                } else {
                    return [...prevData, newEducationData];
                }
            });    
        }
        setShowEducationModal(false);
        setNewEducationData({
            Start: '',
        End: '',
        EducationType: {
            Name: '',
            UID: ''
        },
        EducationKind: {
            Name: '',
            UID: ''
        },
        Institution: {
            Name: '',
            UID: ''
        },
        Faculty: '',
        Speciality: {
            Name: '',
            UID: ''
        },
        DocTypeEducation: {
            Name: '',
            UID: ''
        },
        DocSeries: '',
        DocNumber: '',
        DocDateIssued: ''
        });
        setEditEducation(false);
        setEditEducationIndex(-1);
    };
    
    const handleRemoveEducationRow = (index) => {
        setEducationData(prevData => {
            const newData = [...prevData];
            newData.splice(index, 1); // Удаление элемента по индексу
            return newData;
        });
    };   
    
    const handleCloseEducationModal = () => {
        setShowEducationModal(false);
        setNewEducationData({
            Start: '',
            End: '',
            EducationType: {
                Name: '',
                UID: ''
            },
            EducationKind: {
                Name: '',
                UID: ''
            },
            Institution: {
                Name: '',
                UID: ''
            },
            Faculty: '',
            Speciality: {
                Name: '',
                UID: ''
            },
            DocTypeEducation: {
                Name: '',
                UID: ''
            },
            DocSeries: '',
            DocNumber: '',
            DocDateIssued: ''
        });
        setEditEducation(false);
        setEditEducationIndex(-1);
    };
    
    const handleLanguageChange = (e, option) => {
        const { name, value, dataset } = typeof e === "string" ? option : e.target;
        const { parent } = dataset;
        if (parent) {
            if(dataset.uid) {
                setNewLanguageData(prevState => ({
                    ...prevState,
                    [parent]: {
                        ...prevState[parent],
                        [name]: value,
                        UID: dataset.uid
                    }
                }));
            } else {
                setNewLanguageData(prevState => ({
                    ...prevState,
                    [parent]: {
                        ...prevState[parent],
                        [name]: value
                    }
                }));
            }
        } else {
            setNewLanguageData(prevState => ({
                ...prevState,
                [name]: value
            }));
        }
    };

    const handleLanguageNameChange = (value) => {
        let parent = 'Language';
        setNewLanguageData(prevState => ({
            ...prevState,
            [parent]: {
                ...prevState[parent],
                Name: value,
                UID: ''
            }
        }));
    }
    
    const handleAddLanguageRow = (e) => {
        e.preventDefault();
        if (editLanguage) {
            setLanguageData(prevData => {
                const newData = [...prevData];
                newData[editLanguageIndex] = newLanguageData;
                return newData;
            });
        } else {
            newLanguageData.Deletable = true;
            setLanguageData(prevData => {
                if (prevData.length === 0 || (prevData.length === 1 && isObjectEmpty(prevData))) {
                    return [newLanguageData];
                } else {
                    return [...prevData, newLanguageData];
                }
            });
        }
        setShowLanguageModal(false);
        setNewLanguageData({
            Language: {
                Name: '',
                UID: ''
            },
            LanguageDegree: {
                Name: '',
                UID: ''
            }
        });
        setEditLanguage(false);
        setEditLanguageIndex(-1);
    };
    
    const handleRemoveLanguageRow = (index) => {
        setLanguageData(prevData => {
            const newData = [...prevData];
            newData.splice(index, 1);
            return newData;
        });
    };

    const handleCloseLanguageModal = () => {
        setShowLanguageModal(false);
        setNewLanguageData({
            Language: {
                Name: '',
                UID: ''
            },
            LanguageDegree: {
                Name: '',
                UID: ''
            }
        });
        setEditLanguage(false);
        setEditLanguageIndex(-1);
    };

    const handleComputerSkillsChange = (e, option) => {
        const { name, value, dataset } = typeof e === "string" ? option : e.target;
        const { parent } = dataset;
        if (parent) {
            if(dataset.uid) {
                setNewComputerSkillData(prevState => ({
                    ...prevState,
                    [parent]: {
                        ...prevState[parent],
                        [name]: value,
                        UID: dataset.uid
                    }
                }));
            } else {
                setNewComputerSkillData(prevState => ({
                    ...prevState,
                    [parent]: {
                        ...prevState[parent],
                        [name]: value
                    }
                }));
            }
        } else {
            setNewComputerSkillData(prevState => ({
                ...prevState,
                [name]: value
            }));
        }
    };

    const handleComputerSkillNameChange = (value) => {
        let parent = 'Software';
        setNewComputerSkillData(prevState => ({
            ...prevState,
            [parent]: {
                ...prevState[parent],
                Name: value,
                UID: ''
            }
        }));
    }
    
    const handleAddComputerSkillRow = (e) => {
        e.preventDefault();
        if (editComputerSkill) {
            setComputerSkillsData(prevData => {
                const newData = [...prevData];
                newData[editComputerSkillIndex] = newComputerSkillData;
                return newData;
            });
        } else {
            newComputerSkillData.Deletable = true;
            setComputerSkillsData(prevData => {
                if (prevData.length === 0 || (prevData.length === 1 && isObjectEmpty(prevData))) {
                    return [newComputerSkillData];
                } else {
                    return [...prevData, newComputerSkillData];
                }
            });
        }
        setShowComputerSkillsModal(false);
        setNewComputerSkillData({
            Software: {
                Name: '',
                UID: ''
            },
            SoftwareLevel: {
                Name: '',
                UID: ''
            }
        });
        setEditComputerSkill(false);
        setEditComputerSkillIndex(-1);
    };
    
    const handleRemoveComputerSkillRow = (index) => {
        setComputerSkillsData(prevData => {
            const newData = [...prevData];
            newData.splice(index, 1);
            return newData;
        });
    };

    const handleCloseComputerSkillModal = () => {
        setShowComputerSkillsModal(false);
        setNewComputerSkillData({
            Software: {
                Name: '',
                UID: ''
            },
            SoftwareLevel: {
                Name: '',
                UID: ''
            }
        });
        setEditComputerSkill(false);
        setEditComputerSkillIndex(-1);
    };

    const handleCourseRowChange = (e) => {
        let { name, value } = e.target;
        if(name === 'StartDate' || name === 'EndDate') value += 'T00:00:00';
        setNewCourseData(prevState => ({
            ...prevState,
            [name]: value
        }));
    }

    const handleAddCourseRow = (e) => {
        e.preventDefault();
        if (editCourse) {
            setCoursesData(prevData => {
                const newData = [...prevData];
                newData[editCourseSkillIndex] = newCourseData;
                return newData;
            });
        } else {
            newCourseData.Deletable = true;
            setCoursesData(prevData => {
                if (prevData.length === 0 || (prevData.length === 1 && isObjectEmpty(prevData))) {
                    return [newCourseData];
                } else {
                    return [...prevData, newCourseData];
                }
            });
        }
        setShowCoursesModal(false);
        setNewCourseData({
            Name: "",
            StartDate: "",
            EndDate: ""
        });
        setEditCourse(false);
        setEditCourseIndex(-1);
    };
    
    const handleRemoveCourseRow = (index) => {
        setCoursesData(prevData => {
            const newData = [...prevData];
            newData.splice(index, 1);
            return newData;
        });
    };

    const handleCloseCourseModal = () => {
        setShowCoursesModal(false);
        setNewCourseData({
            Name: "",
            StartDate: "",
            EndDate: ""
        });
        setEditCourse(false);
        setEditCourseIndex(-1);
    };

    const isObjectEmpty = (data) => {
        for (const item of data) {
            for (const key in item) {
                if (typeof item[key] === 'object') {
                    const subItem = item[key];
                    for (const subKey in subItem) {
                        if (subItem[subKey] !== '') {
                            return false;
                        }
                    }
                } else if (item[key] !== '') {
                    return false;
                }
            }
        }
        return true;
    };
    
    const items = [
        {
            key: '1',
            label: 'Образование',
            children: <>
                    <div className='profile-content education-info-content'>
                        <button type='button' className='addButton' onClick={() => setShowEducationModal(true)}><PlusOutlined /> Добавить образование</button> 
                        {!isObjectEmpty(educationData) && educationData.map((edu, index) => (
                            <div key={`edu${index}`} className={'itemCard'}>
                                <h1>{edu.EducationType.Name ? edu.EducationType.Name : 'Не указано'}</h1>
                                <p>{edu.Institution.Name ? edu.Institution.Name : 'Не указано'}</p>
                                <div className={'actions'}>
                                    <button className="btn" onClick={() => {
                                        setNewEducationData(edu);
                                        setEditEducation(true);
                                        setEditEducationIndex(index);
                                        setShowEducationModal(true);
                                    }}><EditOutlined /></button>
                                    <button className="btn" onClick={() => handleRemoveEducationRow(index)}><DeleteOutlined /></button>
                                </div>
                            </div>                                        
                        ))}
                        {showEducationModal && (
                            <>
                            <div className="modal-bg" onClick={() => handleCloseEducationModal()}></div>
                            <div className="modal">
                            <h4 style={{ textAlign: "center", margin: "5px 0 15px" }}>Образование</h4><button type="button" className='btn' style={{ position: "absolute", top: "8px", right: "16px" }} onClick={() => handleCloseEducationModal()} ><CloseOutlined /></button>
                            <table style={{ width: '100%' }}>
                                <tbody> 
                                    <tr>
                                        <td width='40%'><p className='title'>Период</p></td>
                                        <td width='60%'>
                                            С<input
                                                type="date"
                                                name="Start"
                                                value={newEducationData.Start ? newEducationData.Start.split('T')[0] : ''}
                                                onChange={(e) => handleEducationChange(e)}
                                            />
                                            по<input
                                                type="date"
                                                name="End"
                                                value={newEducationData.End ? newEducationData.End.split('T')[0] : ''}
                                                onChange={(e) => handleEducationChange(e)}
                                            />
                                        </td>
                                    </tr> 
                                    <tr>
                                        <td><p className='title'>Вид обучения</p></td>
                                        <td>
                                            <Select
                                                size='small'
                                                value={newEducationData.EducationKind.Name ? newEducationData.EducationKind.Name : undefined}
                                                onChange={(e, option) => handleEducationChange(e, option)}
                                                style={{ width: '100%' }}
                                                placeholder="Выберите вид обучения"
                                                options={selectors.educationKinds}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><p className='title'>Название ВУЗа (ССУ)</p></td>
                                        <td>
                                            {/* <Select
                                                size='small'
                                                showSearch
                                                value={newEducationData.Institution.Name ? newEducationData.Institution.Name : undefined}
                                                onChange={(e, option) => handleEducationChange(e, option)}
                                                style={{ width: '100%' }}
                                                placeholder="Выберите ВУЗ (ССУ)"
                                                optionFilterProp="children"
                                                filterOption={(input, option) => option.label.toLowerCase().includes(input.toLowerCase())}
                                                filterSort={(optionA, optionB) => optionA.label.toLowerCase().localeCompare(optionB.label.toLowerCase())}
                                                notFoundContent={<p style={{color: '#000'}}>Данный элемент отсутствует в базе данных! Оставьте заявку на добавление элемента в системе <a href="https://ithd.it/" target='_blank'>ServiceDesk</a></p>}
                                                options={selectors.institutions}
                                            /> */}
                                            <AutoComplete
                                                allowClear={true}
                                                size='medium'
                                                options={selectors.institutions}
                                                style={{
                                                    width: '100%',
                                                }}
                                                value={newEducationData.Institution.Name}
                                                filterOption={(input, option) => option.label.toLowerCase().includes(input.toLowerCase())}
                                                onSelect={(e, option) => handleEducationChange(e, option)}
                                                onChange={handleInstitutionChange}
                                                placeholder="Название ВУЗа (ССУ)"
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><p className='title'>Факультет</p></td>
                                        <td>
                                            <input
                                                type="text"
                                                name="Faculty"
                                                value={newEducationData.Faculty}
                                                placeholder='Факультет'
                                                onChange={(e) => handleEducationChange(e)}
                                                style={{ marginLeft: '0', width: '100%' }}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><p className='title'>Специальность</p></td>
                                        <td>
                                            {/* <Select
                                                size='small'
                                                style={{ width: '100%' }}
                                                showSearch
                                                notFoundContent={<p style={{color: '#000'}}>Данный элемент отсутствует в базе данных! Оставьте заявку на добавление элемента в системе <a href="https://ithd.it/" target='_blank'>ServiceDesk</a></p>}
                                                value={newEducationData.Speciality.Name ? newEducationData.Speciality.Name : undefined}
                                                onChange={(e, option) => handleEducationChange(e, option)}
                                                placeholder="Специальность"
                                                options={selectors.specialties}
                                            /> */}
                                            <AutoComplete
                                                allowClear={true}
                                                options={selectors.specialties}
                                                style={{
                                                    width: '100%',
                                                }}
                                                value={newEducationData.Speciality.Name}
                                                filterOption={(input, option) => option.label.toLowerCase().includes(input.toLowerCase())}
                                                onSelect={(e, option) => handleEducationChange(e, option)}
                                                onChange={handleSpecialityChange}
                                                placeholder="Специальность"
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><p className='title'>Вид образования</p></td>
                                        <td>
                                            {/* <Select
                                                size='small'
                                                style={{ width: '100%' }}
                                                showSearch
                                                notFoundContent={<p style={{color: '#000'}}>Данный элемент отсутствует в базе данных! Оставьте заявку на добавление элемента в системе <a href="https://ithd.it/" target='_blank'>ServiceDesk</a></p>}
                                                value={newEducationData.EducationType.Name ? newEducationData.EducationType.Name : undefined}
                                                onChange={(e, option) => handleEducationChange(e, option)}
                                                placeholder="Выберите вид образоваия"
                                                options={selectors.educationTypes}
                                            /> */}
                                            <AutoComplete
                                                allowClear={true}
                                                options={selectors.educationTypes}
                                                style={{
                                                    width: '100%',
                                                }}
                                                value={newEducationData.EducationType.Name}
                                                filterOption={(input, option) => option.label.toLowerCase().includes(input.toLowerCase())}
                                                onSelect={(e, option) => handleEducationChange(e, option)}
                                                onChange={handleEducationTypeChange}
                                                placeholder="Выберите вид образоваия"
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><p className='title'>Вид документа</p></td>
                                        <td>
                                            <Select
                                                size='small'
                                                value={newEducationData.DocTypeEducation.Name ? newEducationData.DocTypeEducation.Name : undefined}
                                                onChange={(e, option) => handleEducationChange(e, option)}
                                                style={{ width: '100%' }}
                                                placeholder="Выберите вид документа"
                                                options={selectors.docTypesEducation}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><p className='title'>Серия документа</p></td>
                                        <td>
                                            <input
                                                style={{ margin: '7px 0 0 5px' }}
                                                width="40%"
                                                type="text"
                                                name="DocSeries"
                                                placeholder='Серия'
                                                value={newEducationData.DocSeries}
                                                onChange={(e) => handleEducationChange(e)}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><p className='title'>Номер документа</p></td>
                                        <td>
                                            <input
                                                style={{ margin: '7px 0 0 5px' }}
                                                width="40%"
                                                type="number"
                                                name="DocNumber"
                                                placeholder='Номер'
                                                value={newEducationData.DocNumber}
                                                onChange={(e) => handleEducationChange(e)}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><p className='title'>Дата выдачи</p></td>
                                        <td>
                                            <input
                                                style={{ margin: '7px 0 0 5px' }}
                                                width="40%"
                                                type="date"
                                                name="DocDateIssued"
                                                value={newEducationData.DocDateIssued ? newEducationData.DocDateIssued.split('T')[0] : ''}
                                                onChange={(e) => handleEducationChange(e)}
                                            />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <div style={{ marginTop: "32px" }}></div>
                            <button className='btn' type='button' style={{ position: "absolute", bottom: "8px", right: "16px" }} onClick={(e) => handleAddEducationRow(e)}>ОК</button>
                            </div>
                            </>
                        )}
                    </div>
                </>,
        },
        {
            key: '2',
            label: 'Знание языков',
            children: <>
                <div className='profile-content education-info-content'>
                    <button type='button' className='addButton' onClick={() => setShowLanguageModal(true)}><PlusOutlined /> Добавить язык</button>
                    {!isObjectEmpty(languageData) && languageData.map((lang, index) => (
                        <div key={`lang${index}`} className={'itemCard'}>
                            <h1>{lang.Language.Name ? lang.Language.Name : 'Не указано'}</h1>
                            <p>{lang.LanguageDegree.Name ? lang.LanguageDegree.Name : 'Не указано'}</p>
                            <div className={'actions'}>
                                <button className="btn" onClick={() => {
                                    setNewLanguageData(lang);
                                    setEditLanguage(true);
                                    setEditLanguageIndex(index);
                                    setShowLanguageModal(true);
                                }}><EditOutlined /></button>
                                <button className="btn" onClick={() => handleRemoveLanguageRow(index)}><DeleteOutlined /></button>
                            </div>
                        </div>  
                    ))}
                    {showLanguageModal && (
                        <>
                            <div className="modal-bg" onClick={() => handleCloseLanguageModal()}></div>
                            <div className="modal">
                                <h4 style={{ textAlign: "center", margin: "5px 0 15px" }}>Язык</h4>
                                <button type="button" className='btn' style={{ position: "absolute", top: "8px", right: "16px" }} onClick={() => handleCloseLanguageModal()} ><CloseOutlined /></button>
                                <table style={{ width: '100%' }}>
                                    <tbody>
                                        <tr>
                                            <td width='40%'><p className='title'>Язык</p></td>
                                            <td width='60%'>
                                                {/* <Select
                                                    size='small'
                                                    showSearch
                                                    notFoundContent={<p style={{color: '#000'}}>Данный элемент отсутствует в базе данных! Оставьте заявку на добавление элемента в системе <a href="https://ithd.it/" target='_blank'>ServiceDesk</a></p>}
                                                    value={newLanguageData.Language.Name ? newLanguageData.Language.Name : undefined}
                                                    onChange={(e, option) => handleLanguageChange(e, option)}
                                                    style={{ width: '100%' }}
                                                    placeholder="Выберите язык"
                                                    options={selectors.languages}
                                                /> */}
                                                <AutoComplete
                                                    allowClear={true}
                                                    size='medium'
                                                    options={selectors.languages}
                                                    style={{
                                                        width: '100%',
                                                    }}
                                                    value={newLanguageData.Language.Name}
                                                    filterOption={(input, option) => option.label.toLowerCase().includes(input.toLowerCase())}
                                                    onSelect={(e, option) => handleLanguageChange(e, option)}
                                                    onChange={handleLanguageNameChange}
                                                    placeholder="Выберите язык"
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td><p className='title'>Степень владения</p></td>
                                            <td>
                                                <Select
                                                    size='small'
                                                    value={newLanguageData.LanguageDegree.Name ? newLanguageData.LanguageDegree.Name : undefined}
                                                    onChange={(e, option) => handleLanguageChange(e, option)}
                                                    style={{ width: '100%' }}
                                                    placeholder="Уровень владения"
                                                    options={selectors.languageDegrees}
                                                />
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div style={{ marginTop: "32px" }}></div>
                                <button className='btn' type='button' style={{ position: "absolute", bottom: "8px", right: "16px" }} onClick={(e) => handleAddLanguageRow(e)}>ОК</button>
                            </div>
                        </>
                    )}
                </div>
            </>,
        },
        {
            key: '3',
            label: 'Компьютерная грамотность',
            children: <>
                <div className='profile-content education-info-content'>
                    <button type='button' className='addButton' onClick={() => setShowComputerSkillsModal(true)}><PlusOutlined /> Добавить программное обеспечение</button>
                    {!isObjectEmpty(computerSkillsData) && computerSkillsData.map((comp, index) => (
                        <div key={`comp${index}`} className={'itemCard'}>
                            <h1>{comp.Software.Name ? comp.Software.Name : 'Не указано'}</h1>
                            <p>{comp.SoftwareLevel.Name ? comp.SoftwareLevel.Name : 'Не указано'}</p>
                            <div className={'actions'}>
                                <button className="btn" onClick={() => {
                                    setNewComputerSkillData(comp);
                                    setEditComputerSkill(true);
                                    setEditComputerSkillIndex(index);
                                    setShowComputerSkillsModal(true);
                                }}><EditOutlined /></button>
                                <button className="btn" onClick={() => handleRemoveComputerSkillRow(index)}><DeleteOutlined /></button>
                            </div>
                        </div> 
                    ))}
                    {showComputerSkillsModal && (
                        <>
                            <div className="modal-bg" onClick={() => handleCloseComputerSkillModal()}></div>
                            <div className="modal">
                                <h4 style={{ textAlign: "center", margin: "5px 0 15px" }}>Компьютерные навыки</h4>
                                <button type="button" className='btn' style={{ position: "absolute", top: "8px", right: "16px" }} onClick={() => handleCloseComputerSkillModal()} ><CloseOutlined /></button>
                                <table style={{ width: '100%' }}>
                                    <tbody>
                                        <tr>
                                            <td width='40%'><p className='title'>Программное обеспечение</p></td>
                                            <td width='60%'>
                                                {/* <Select
                                                    size='small'
                                                    value={newComputerSkillData.Software.Name ? newComputerSkillData.Software.Name : undefined}
                                                    onChange={handleComputerSkillsChange}
                                                    style={{ width: '100%' }}
                                                    placeholder="Выберите ПО"
                                                    options={selectors.softwares}
                                                /> */}
                                                <AutoComplete
                                                    allowClear={true}
                                                    size='medium'
                                                    options={selectors.softwares}
                                                    style={{
                                                        width: '100%',
                                                    }}
                                                    value={newComputerSkillData.Software.Name}
                                                    filterOption={(input, option) => option.label.toLowerCase().includes(input.toLowerCase())}
                                                    onSelect={(e, option) => handleComputerSkillsChange(e, option)}
                                                    onChange={handleComputerSkillNameChange}
                                                    placeholder="Выберите ПО"
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td><p className='title'>Уровень владения</p></td>
                                            <td>
                                                <Select
                                                    size='small'
                                                    value={newComputerSkillData.SoftwareLevel.Name ? newComputerSkillData.SoftwareLevel.Name : undefined}
                                                    onChange={handleComputerSkillsChange}
                                                    style={{ width: '100%' }}
                                                    placeholder="Выберите уровень владения"
                                                    options={selectors.softwareLevels}
                                                />
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div style={{ marginTop: "32px" }}></div>
                                <button className='btn' type='button' style={{ position: "absolute", bottom: "8px", right: "16px" }} onClick={(e) => handleAddComputerSkillRow(e)}>ОК</button>
                            </div>
                        </>
                    )}
                </div>
            </>,
        },
        {
            key: '4',
            label: 'Курсы, тренинги',
            children: <>
                <div className='profile-content education-info-content'>
                    <button type='button' className='addButton' onClick={() => setShowCoursesModal(true)}><PlusOutlined /> Добавить данные о курсах</button>
                    {!isObjectEmpty(coursesData) && coursesData.map((course, index) => (
                        <div key={`course${index}`} className={'itemCard'}>
                            <h1>{course.Name ? course.Name : 'Не указано'}</h1>
                            <p>С {course.StartDate ? course.StartDate.split('T')[0] : 'Не указано'} ПО {course.EndDate ? course.EndDate.split('T')[0] : 'Не указано'}</p>
                            <div className={'actions'}>
                                <button className="btn" onClick={() => {
                                    setNewCourseData(course);
                                    setEditCourse(true);
                                    setEditCourseIndex(index);
                                    setShowCoursesModal(true);
                                }}><EditOutlined /></button>
                                <button className="btn" onClick={() => handleRemoveCourseRow(index)}><DeleteOutlined /></button>
                            </div>
                        </div> 
                    ))}
                    {showCoursesModal && (
                        <>
                            <div className="modal-bg" onClick={() => handleCloseCourseModal()}></div>
                            <div className="modal">
                                <h4 style={{ textAlign: "center", margin: "5px 0 15px" }}>Повышения квалификации, курсы, тренинги</h4>
                                <button type="button" className='btn' style={{ position: "absolute", top: "8px", right: "16px" }} onClick={() => handleCloseCourseModal()} ><CloseOutlined /></button>
                                <table style={{ width: '100%' }}>
                                    <tbody>
                                        <tr>
                                            <td width='40%'><p className='title'>Период</p></td>
                                            <td width='60%'>
                                                С<input
                                                    type="date"
                                                    name="StartDate"
                                                    value={newCourseData.StartDate ? newCourseData.StartDate.split('T')[0] : ''}
                                                    onChange={(e) => handleCourseRowChange(e)}
                                                />
                                                по<input
                                                    type="date"
                                                    name="EndDate"
                                                    value={newCourseData.EndDate ? newCourseData.EndDate.split('T')[0] : ''}
                                                    onChange={(e) => handleCourseRowChange(e)}
                                                />
                                            </td>
                                        </tr> 
                                        <tr>
                                            <td><p className='title'>Название курса, тренинга</p></td>
                                            <td>
                                                <input
                                                    type="text"
                                                    name="Name"
                                                    value={newCourseData.Name}
                                                    placeholder='Название курса, тренинга'
                                                    onChange={(e) => handleCourseRowChange(e)}
                                                    style={{ marginLeft: '0', width: '100%' }}
                                                />
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div style={{ marginTop: "32px" }}></div>
                                <button className='btn' type='button' style={{ position: "absolute", bottom: "8px", right: "16px" }} onClick={(e) => handleAddCourseRow(e)}>ОК</button>
                            </div>
                        </>
                    )}
                </div>
            </>,
        },
    ];
    
    return (
        <>
        <div style={{ background: '#fff' }}>
        <Tabs
            defaultActiveKey="1"
            tabPosition='left'
            size="small"
            className='educationTabs'
            items={[
                {
                    label: 'Образование',
                    key: 1,
                    children: <>
                        <div className='profile-content education-info-content'>
                            <button type='button' className='addButton' onClick={() => setShowEducationModal(true)}><PlusOutlined /> Добавить образование</button> 
                            {!isObjectEmpty(educationData) && educationData.map((edu, index) => (
                                <div key={`edu${index}`} className={'itemCard'}>
                                    <h1>{edu.EducationType.Name ? edu.EducationType.Name : 'Не указано'}</h1>
                                    <p>{edu.Institution.Name ? edu.Institution.Name : 'Не указано'}</p>
                                    <div className={'actions'}>
                                        <button className="btn" onClick={() => {
                                            setNewEducationData(edu);
                                            setEditEducation(true);
                                            setEditEducationIndex(index);
                                            setShowEducationModal(true);
                                        }}><EditOutlined /></button>
                                        <button className="btn" onClick={() => handleRemoveEducationRow(index)}><DeleteOutlined /></button>
                                    </div>
                                </div>                                        
                            ))}
                            {showEducationModal && (
                                <>
                                <div className="modal-bg" onClick={() => handleCloseEducationModal()}></div>
                                <div className="modal">
                                <h4 style={{ textAlign: "center", margin: "5px 0 15px" }}>Образование</h4><button type="button" className='btn' style={{ position: "absolute", top: "8px", right: "16px" }} onClick={() => handleCloseEducationModal()} ><CloseOutlined /></button>
                                <table style={{ width: '100%' }}>
                                    <tbody> 
                                        <tr>
                                            <td width='40%'><p className='title'>Период</p></td>
                                            <td width='60%'>
                                                С<input
                                                    type="date"
                                                    name="Start"
                                                    value={newEducationData.Start ? newEducationData.Start.split('T')[0] : ''}
                                                    onChange={(e) => handleEducationChange(e)}
                                                />
                                                по<input
                                                    type="date"
                                                    name="End"
                                                    value={newEducationData.End ? newEducationData.End.split('T')[0] : ''}
                                                    onChange={(e) => handleEducationChange(e)}
                                                />
                                            </td>
                                        </tr> 
                                        <tr>
                                            <td><p className='title'>Вид обучения</p></td>
                                            <td>
                                                <Select
                                                    size='small'
                                                    value={newEducationData.EducationKind.Name ? newEducationData.EducationKind.Name : undefined}
                                                    onChange={(e, option) => handleEducationChange(e, option)}
                                                    style={{ width: '100%' }}
                                                    placeholder="Выберите вид обучения"
                                                    options={selectors.educationKinds}
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td><p className='title'>Название ВУЗа (ССУ)</p></td>
                                            <td>
                                                {/* <Select
                                                    size='small'
                                                    showSearch
                                                    value={newEducationData.Institution.Name ? newEducationData.Institution.Name : undefined}
                                                    onChange={(e, option) => handleEducationChange(e, option)}
                                                    style={{ width: '100%' }}
                                                    placeholder="Выберите ВУЗ (ССУ)"
                                                    optionFilterProp="children"
                                                    filterOption={(input, option) => option.label.toLowerCase().includes(input.toLowerCase())}
                                                    filterSort={(optionA, optionB) => optionA.label.toLowerCase().localeCompare(optionB.label.toLowerCase())}
                                                    notFoundContent={<p style={{color: '#000'}}>Данный элемент отсутствует в базе данных! Оставьте заявку на добавление элемента в системе <a href="https://ithd.it/" target='_blank'>ServiceDesk</a></p>}
                                                    options={selectors.institutions}
                                                /> */}
                                                <AutoComplete
                                                    allowClear={true}
                                                    size='medium'
                                                    options={selectors.institutions}
                                                    style={{
                                                        width: '100%',
                                                    }}
                                                    value={newEducationData.Institution.Name}
                                                    filterOption={(input, option) => option.label.toLowerCase().includes(input.toLowerCase())}
                                                    onSelect={(e, option) => handleEducationChange(e, option)}
                                                    onChange={handleInstitutionChange}
                                                    placeholder="Название ВУЗа (ССУ)"
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td><p className='title'>Факультет</p></td>
                                            <td>
                                                <input
                                                    type="text"
                                                    name="Faculty"
                                                    value={newEducationData.Faculty}
                                                    placeholder='Факультет'
                                                    onChange={(e) => handleEducationChange(e)}
                                                    style={{ marginLeft: '0', width: '100%' }}
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td><p className='title'>Специальность</p></td>
                                            <td>
                                                {/* <Select
                                                    size='small'
                                                    style={{ width: '100%' }}
                                                    showSearch
                                                    notFoundContent={<p style={{color: '#000'}}>Данный элемент отсутствует в базе данных! Оставьте заявку на добавление элемента в системе <a href="https://ithd.it/" target='_blank'>ServiceDesk</a></p>}
                                                    value={newEducationData.Speciality.Name ? newEducationData.Speciality.Name : undefined}
                                                    onChange={(e, option) => handleEducationChange(e, option)}
                                                    placeholder="Специальность"
                                                    options={selectors.specialties}
                                                /> */}
                                                <AutoComplete
                                                    allowClear={true}
                                                    options={selectors.specialties}
                                                    style={{
                                                        width: '100%',
                                                    }}
                                                    value={newEducationData.Speciality.Name}
                                                    filterOption={(input, option) => option.label.toLowerCase().includes(input.toLowerCase())}
                                                    onSelect={(e, option) => handleEducationChange(e, option)}
                                                    onChange={handleSpecialityChange}
                                                    placeholder="Специальность"
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td><p className='title'>Вид образования</p></td>
                                            <td>
                                                {/* <Select
                                                    size='small'
                                                    style={{ width: '100%' }}
                                                    showSearch
                                                    notFoundContent={<p style={{color: '#000'}}>Данный элемент отсутствует в базе данных! Оставьте заявку на добавление элемента в системе <a href="https://ithd.it/" target='_blank'>ServiceDesk</a></p>}
                                                    value={newEducationData.EducationType.Name ? newEducationData.EducationType.Name : undefined}
                                                    onChange={(e, option) => handleEducationChange(e, option)}
                                                    placeholder="Выберите вид образоваия"
                                                    options={selectors.educationTypes}
                                                /> */}
                                                <AutoComplete
                                                    allowClear={true}
                                                    options={selectors.educationTypes}
                                                    style={{
                                                        width: '100%',
                                                    }}
                                                    value={newEducationData.EducationType.Name}
                                                    filterOption={(input, option) => option.label.toLowerCase().includes(input.toLowerCase())}
                                                    onSelect={(e, option) => handleEducationChange(e, option)}
                                                    onChange={handleEducationTypeChange}
                                                    placeholder="Выберите вид образоваия"
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td><p className='title'>Вид документа</p></td>
                                            <td>
                                                <Select
                                                    size='small'
                                                    value={newEducationData.DocTypeEducation.Name ? newEducationData.DocTypeEducation.Name : undefined}
                                                    onChange={(e, option) => handleEducationChange(e, option)}
                                                    style={{ width: '100%' }}
                                                    placeholder="Выберите вид документа"
                                                    options={selectors.docTypesEducation}
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td><p className='title'>Серия документа</p></td>
                                            <td>
                                                <input
                                                    style={{ margin: '7px 0 0 5px' }}
                                                    width="40%"
                                                    type="text"
                                                    name="DocSeries"
                                                    placeholder='Серия'
                                                    value={newEducationData.DocSeries}
                                                    onChange={(e) => handleEducationChange(e)}
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td><p className='title'>Номер документа</p></td>
                                            <td>
                                                <input
                                                    style={{ margin: '7px 0 0 5px' }}
                                                    width="40%"
                                                    type="number"
                                                    name="DocNumber"
                                                    placeholder='Номер'
                                                    value={newEducationData.DocNumber}
                                                    onChange={(e) => handleEducationChange(e)}
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td><p className='title'>Дата выдачи</p></td>
                                            <td>
                                                <input
                                                    style={{ margin: '7px 0 0 5px' }}
                                                    width="40%"
                                                    type="date"
                                                    name="DocDateIssued"
                                                    value={newEducationData.DocDateIssued ? newEducationData.DocDateIssued.split('T')[0] : ''}
                                                    onChange={(e) => handleEducationChange(e)}
                                                />
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div style={{ marginTop: "32px" }}></div>
                                <button className='btn' type='button' style={{ position: "absolute", bottom: "8px", right: "16px" }} onClick={(e) => handleAddEducationRow(e)}>ОК</button>
                                </div>
                                </>
                            )}
                        </div>
                    </>,
                },
                {
                    label: 'Знание языков',
                    key: 2,
                    children: <>
                        <div className='profile-content education-info-content'>
                            <button type='button' className='addButton' onClick={() => setShowLanguageModal(true)}><PlusOutlined /> Добавить язык</button>
                            {!isObjectEmpty(languageData) && languageData.map((lang, index) => (
                                <div key={`lang${index}`} className={'itemCard'}>
                                    <h1>{lang.Language.Name ? lang.Language.Name : 'Не указано'}</h1>
                                    <p>{lang.LanguageDegree.Name ? lang.LanguageDegree.Name : 'Не указано'}</p>
                                    <div className={'actions'}>
                                        <button className="btn" onClick={() => {
                                            setNewLanguageData(lang);
                                            setEditLanguage(true);
                                            setEditLanguageIndex(index);
                                            setShowLanguageModal(true);
                                        }}><EditOutlined /></button>
                                        <button className="btn" onClick={() => handleRemoveLanguageRow(index)}><DeleteOutlined /></button>
                                    </div>
                                </div>  
                            ))}
                            {showLanguageModal && (
                                <>
                                    <div className="modal-bg" onClick={() => handleCloseLanguageModal()}></div>
                                    <div className="modal">
                                        <h4 style={{ textAlign: "center", margin: "5px 0 15px" }}>Язык</h4>
                                        <button type="button" className='btn' style={{ position: "absolute", top: "8px", right: "16px" }} onClick={() => handleCloseLanguageModal()} ><CloseOutlined /></button>
                                        <table style={{ width: '100%' }}>
                                            <tbody>
                                                <tr>
                                                    <td width='40%'><p className='title'>Язык</p></td>
                                                    <td width='60%'>
                                                        {/* <Select
                                                            size='small'
                                                            showSearch
                                                            notFoundContent={<p style={{color: '#000'}}>Данный элемент отсутствует в базе данных! Оставьте заявку на добавление элемента в системе <a href="https://ithd.it/" target='_blank'>ServiceDesk</a></p>}
                                                            value={newLanguageData.Language.Name ? newLanguageData.Language.Name : undefined}
                                                            onChange={(e, option) => handleLanguageChange(e, option)}
                                                            style={{ width: '100%' }}
                                                            placeholder="Выберите язык"
                                                            options={selectors.languages}
                                                        /> */}
                                                        <AutoComplete
                                                            allowClear={true}
                                                            size='medium'
                                                            options={selectors.languages}
                                                            style={{
                                                                width: '100%',
                                                            }}
                                                            value={newLanguageData.Language.Name}
                                                            filterOption={(input, option) => option.label.toLowerCase().includes(input.toLowerCase())}
                                                            onSelect={(e, option) => handleLanguageChange(e, option)}
                                                            onChange={handleLanguageNameChange}
                                                            placeholder="Выберите язык"
                                                        />
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td><p className='title'>Степень владения</p></td>
                                                    <td>
                                                        <Select
                                                            size='small'
                                                            value={newLanguageData.LanguageDegree.Name ? newLanguageData.LanguageDegree.Name : undefined}
                                                            onChange={(e, option) => handleLanguageChange(e, option)}
                                                            style={{ width: '100%' }}
                                                            placeholder="Уровень владения"
                                                            options={selectors.languageDegrees}
                                                        />
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <div style={{ marginTop: "32px" }}></div>
                                        <button className='btn' type='button' style={{ position: "absolute", bottom: "8px", right: "16px" }} onClick={(e) => handleAddLanguageRow(e)}>ОК</button>
                                    </div>
                                </>
                            )}
                        </div>
                    </>,
                },
                {
                    label: 'Компьютерная грамотность',
                    key: 3,
                    children: <>
                        <div className='profile-content education-info-content'>
                            <button type='button' className='addButton' onClick={() => setShowComputerSkillsModal(true)}><PlusOutlined /> Добавить программное обеспечение</button>
                            {!isObjectEmpty(computerSkillsData) && computerSkillsData.map((comp, index) => (
                                <div key={`comp${index}`} className={'itemCard'}>
                                    <h1>{comp.Software.Name ? comp.Software.Name : 'Не указано'}</h1>
                                    <p>{comp.SoftwareLevel.Name ? comp.SoftwareLevel.Name : 'Не указано'}</p>
                                    <div className={'actions'}>
                                        <button className="btn" onClick={() => {
                                            setNewComputerSkillData(comp);
                                            setEditComputerSkill(true);
                                            setEditComputerSkillIndex(index);
                                            setShowComputerSkillsModal(true);
                                        }}><EditOutlined /></button>
                                        <button className="btn" onClick={() => handleRemoveComputerSkillRow(index)}><DeleteOutlined /></button>
                                    </div>
                                </div> 
                            ))}
                            {showComputerSkillsModal && (
                                <>
                                    <div className="modal-bg" onClick={() => handleCloseComputerSkillModal()}></div>
                                    <div className="modal">
                                        <h4 style={{ textAlign: "center", margin: "5px 0 15px" }}>Компьютерные навыки</h4>
                                        <button type="button" className='btn' style={{ position: "absolute", top: "8px", right: "16px" }} onClick={() => handleCloseComputerSkillModal()} ><CloseOutlined /></button>
                                        <table style={{ width: '100%' }}>
                                            <tbody>
                                                <tr>
                                                    <td width='40%'><p className='title'>Программное обеспечение</p></td>
                                                    <td width='60%'>
                                                        {/* <Select
                                                            size='small'
                                                            value={newComputerSkillData.Software.Name ? newComputerSkillData.Software.Name : undefined}
                                                            onChange={handleComputerSkillsChange}
                                                            style={{ width: '100%' }}
                                                            placeholder="Выберите ПО"
                                                            options={selectors.softwares}
                                                        /> */}
                                                        <AutoComplete
                                                            allowClear={true}
                                                            size='medium'
                                                            options={selectors.softwares}
                                                            style={{
                                                                width: '100%',
                                                            }}
                                                            value={newComputerSkillData.Software.Name}
                                                            filterOption={(input, option) => option.label.toLowerCase().includes(input.toLowerCase())}
                                                            onSelect={(e, option) => handleComputerSkillsChange(e, option)}
                                                            onChange={handleComputerSkillNameChange}
                                                            placeholder="Выберите ПО"
                                                        />
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td><p className='title'>Уровень владения</p></td>
                                                    <td>
                                                        <Select
                                                            size='small'
                                                            value={newComputerSkillData.SoftwareLevel.Name ? newComputerSkillData.SoftwareLevel.Name : undefined}
                                                            onChange={handleComputerSkillsChange}
                                                            style={{ width: '100%' }}
                                                            placeholder="Выберите уровень владения"
                                                            options={selectors.softwareLevels}
                                                        />
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <div style={{ marginTop: "32px" }}></div>
                                        <button className='btn' type='button' style={{ position: "absolute", bottom: "8px", right: "16px" }} onClick={(e) => handleAddComputerSkillRow(e)}>ОК</button>
                                    </div>
                                </>
                            )}
                        </div>
                    </>,
                },
                {
                    label: 'Курсы, тренинги',
                    key: 4,
                    children: <>
                        <div className='profile-content education-info-content'>
                            <button type='button' className='addButton' onClick={() => setShowCoursesModal(true)}><PlusOutlined /> Добавить данные о курсах</button>
                            {!isObjectEmpty(coursesData) && coursesData.map((course, index) => (
                                <div key={`course${index}`} className={'itemCard'}>
                                    <h1>{course.Name ? course.Name : 'Не указано'}</h1>
                                    <p>С {course.StartDate ? course.StartDate.split('T')[0] : 'Не указано'} ПО {course.EndDate ? course.EndDate.split('T')[0] : 'Не указано'}</p>
                                    <div className={'actions'}>
                                        <button className="btn" onClick={() => {
                                            setNewCourseData(course);
                                            setEditCourse(true);
                                            setEditCourseIndex(index);
                                            setShowCoursesModal(true);
                                        }}><EditOutlined /></button>
                                        <button className="btn" onClick={() => handleRemoveCourseRow(index)}><DeleteOutlined /></button>
                                    </div>
                                </div> 
                            ))}
                            {showCoursesModal && (
                                <>
                                    <div className="modal-bg" onClick={() => handleCloseCourseModal()}></div>
                                    <div className="modal">
                                        <h4 style={{ textAlign: "center", margin: "5px 0 15px" }}>Повышения квалификации, курсы, тренинги</h4>
                                        <button type="button" className='btn' style={{ position: "absolute", top: "8px", right: "16px" }} onClick={() => handleCloseCourseModal()} ><CloseOutlined /></button>
                                        <table style={{ width: '100%' }}>
                                            <tbody>
                                                <tr>
                                                    <td width='40%'><p className='title'>Период</p></td>
                                                    <td width='60%'>
                                                        С<input
                                                            type="date"
                                                            name="StartDate"
                                                            value={newCourseData.StartDate ? newCourseData.StartDate.split('T')[0] : ''}
                                                            onChange={(e) => handleCourseRowChange(e)}
                                                        />
                                                        по<input
                                                            type="date"
                                                            name="EndDate"
                                                            value={newCourseData.EndDate ? newCourseData.EndDate.split('T')[0] : ''}
                                                            onChange={(e) => handleCourseRowChange(e)}
                                                        />
                                                    </td>
                                                </tr> 
                                                <tr>
                                                    <td><p className='title'>Название курса, тренинга</p></td>
                                                    <td>
                                                        <input
                                                            type="text"
                                                            name="Name"
                                                            value={newCourseData.Name}
                                                            placeholder='Название курса, тренинга'
                                                            onChange={(e) => handleCourseRowChange(e)}
                                                            style={{ marginLeft: '0', width: '100%' }}
                                                        />
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <div style={{ marginTop: "32px" }}></div>
                                        <button className='btn' type='button' style={{ position: "absolute", bottom: "8px", right: "16px" }} onClick={(e) => handleAddCourseRow(e)}>ОК</button>
                                    </div>
                                </>
                            )}
                        </div>
                    </>,
                },
            ]}
        />  
        <Collapse items={items} accordion defaultActiveKey={['1']} className='educationCollaps'/>
        </div>      
        </>
    );
};

export default EducationInfo;
